import { connect } from 'react-redux';
import ViewDrawer from './ViewDrawer';
import {
  setConfirmDialogOpen,
  setConfirmDialogType,
  setCustomerAuthorization,
  setCustomerAuthorizationToDelete,
  setIsViewDrawerOpen,
} from '../store/customerAuthorizationSlice';

const mapState = state => ({
  customerAuthorization: state.loadingManagement.customerAuthorizations.customerAuthorization,
  isFetchingCustomerAuthorization:
    state.loadingManagement.customerAuthorizations.isFetchingCustomerAuthorization,
  isViewDrawerOpen: state.loadingManagement.customerAuthorizations.isViewDrawerOpen,
});

const mapDispatchToProps = {
  setConfirmDialogOpen,
  setConfirmDialogType,
  setCustomerAuthorization,
  setCustomerAuthorizationToDelete,
  setIsViewDrawerOpen,
};

export default connect(mapState, mapDispatchToProps)(ViewDrawer);
